import { createAsyncThunk } from '@reduxjs/toolkit';
import { TableFilter } from '../../../../components/Table/models/table-filter';
import { objectToQueryString } from '../../../../utils/queryHelper';
import createNotification from '../../../../utils/createNotification';

export const GetOpportunityDocuments = createAsyncThunk(
    'marketplace/getOpportunityDocuments',
    async (
        {
            opportunityId,
            sectionId,
            filterParams,
        }: {
            opportunityId: number;
            sectionId: string;
            filterParams: TableFilter;
        },
        dispatch: any
    ) => {
        const axios = dispatch.getState().core.axios;
        const queryString = objectToQueryString(filterParams);

        try {
            const response = await axios.get(
                `/api/Marketplace/${opportunityId}/MarketplaceOpportunityDocuments?sectionId=${sectionId}&${queryString}`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not fetch documents at the moment.',
                    'error'
                );
                throw new Error('Failed to fetch documents');
            }

            return {
                documents: response.data.list,
                pageNumber: response.data.pageNumber,
                totalItems: response.data.totalItems,
                pageSize: response.data.pageSize,
                opportunityId: opportunityId,
                sectionId: sectionId,
            };
        } catch (error) {
            createNotification(
                'An error occurred while fetching documents.',
                'error'
            );
            throw error;
        }
    }
);
